import React from 'react';
import CandidateSlotProposal from '../../Components/CandidateSlotProposal/CandidateSlotProposal';
import ConnectRepository from '../../Repositories/ConnectRepository';

// Nothing here comes from the store: the offer resolves anonymously off the link.
const repository = new ConnectRepository();

const CandidateSlotProposalContainer = () => <CandidateSlotProposal repository={repository} />;

export default CandidateSlotProposalContainer;
